import React from "react";
export const SearchIconGray = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6643 14.471L19.3224 18.1291C19.464 18.2707 19.464 18.4997 19.3224 18.6414L18.6414 19.3224C18.4997 19.464 18.2707 19.464 18.1291 19.3224L14.471 15.6643C14.4047 15.595 14.3656 15.5046 14.3656 15.4081V15.0104C13.2657 15.9596 11.8344 16.5351 10.2676 16.5351C6.80533 16.5351 4 13.7298 4 10.2676C4 6.80533 6.80533 4 10.2676 4C13.7298 4 16.5351 6.80533 16.5351 10.2676C16.5351 11.8344 15.9596 13.2657 15.0104 14.3656H15.4081C15.5046 14.3656 15.595 14.4017 15.6643 14.471ZM5.44628 10.2675C5.44628 12.9312 7.60377 15.0887 10.2675 15.0887C12.9312 15.0887 15.0887 12.9312 15.0887 10.2675C15.0887 7.60377 12.9312 5.44628 10.2675 5.44628C7.60377 5.44628 5.44628 7.60377 5.44628 10.2675Z"
        fill="#949494"
      />
    </svg>
  );
};

export const DropDownIcon = () => {
  return (
    <svg
      width="8"
      height="5"
      viewBox="0 0 8 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.29289 0H0.707107C0.261654 0 0.03857 0.53857 0.353552 0.853552L3.64645 4.14645C3.84171 4.34171 4.15829 4.34171 4.35355 4.14645L7.64645 0.853553C7.96143 0.538571 7.73835 0 7.29289 0Z"
        fill="#2C2C2C"
      />
    </svg>
  );
};

export const AmwayMobileIcon = () => {
  return (
    <svg
      width="84"
      height="28"
      viewBox="0 0 84 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.4402 22.2836C81.0497 23.1402 84 23.9878 84 23.9878L83.8904 24.3592C81.0018 23.7019 78.031 23.1739 75.0111 22.7574C74.3571 23.3248 73.4315 23.5893 70.7369 23.5893C70.4192 23.5893 70.2403 23.5745 70.0151 23.5558C69.9361 23.5493 69.8514 23.5423 69.7531 23.5353V22.1473C36.6849 18.9955 0 27.7756 0 27.7756L0.598043 25.943C31.9953 19.385 55.7744 20.0019 69.7474 21.5395V20.4015H70.7312C71.0839 20.4015 71.9159 20.4015 72.2948 20.0469C72.5972 19.8015 72.8495 19.2004 72.8495 18.6275C72.8495 18.3269 72.6977 17.781 72.5721 17.4264L68.5502 5.18616V19.286H64.9197V17.7303C64.4711 18.3854 63.614 19.5865 61.4958 19.5865C58.3937 19.5865 56.0734 16.8568 56.0734 12.4364C56.0734 6.86899 59.3022 4.79443 61.7731 4.79443C63.21 4.79443 64.3456 5.58576 65.0007 6.95117V5.12312H68.5559V5.15014H72.5778L74.9506 14.6742L77.1191 5.15014H80.8854L76.7322 19.1734C76.4674 20.0537 76.0485 21.4359 75.4402 22.2836ZM62.1611 16.2771C62.3883 16.2771 63.1198 16.2253 63.7761 15.4892C64.5567 14.5616 64.7336 13.3336 64.7314 12.0537C64.7314 10.2257 64.2771 9.26999 63.7989 8.75219C63.431 8.31396 62.8896 8.05313 62.3129 8.03629C61.6316 8.03629 60.9285 8.44489 60.472 9.073C59.842 9.97239 59.6902 11.0913 59.6902 12.1832C59.6902 13.0567 59.7918 13.9031 60.0931 14.6123C60.5976 15.8404 61.4307 16.2771 62.1611 16.2771Z"
        fill="#2C2C2C"
      />
      <path
        d="M45.356 19.3228L47.5127 9.86308L49.6955 19.3228H53.1315L56.8943 5.32275H53.1315L51.1507 14.0801L49.1427 5.32275H45.8827L43.852 14.0801L41.8713 5.32275H38.1084L41.8713 19.3228H45.356Z"
        fill="#2C2C2C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0095 15.2257H8.16048L6.99548 19.3228H2.41553L8.65208 0.0397949H13.3109L19.3005 17.8188V5.21041H22.9933V7.11454C23.0003 7.09952 23.0074 7.08427 23.0146 7.06881C23.1891 6.69442 23.4221 6.19475 24.004 5.7241C24.6613 5.17894 25.6205 4.87882 26.5557 4.87882C27.0461 4.88087 27.5326 4.9637 27.9951 5.12386C29.486 5.67014 29.9147 6.81442 30.0919 7.30451C31.2546 5.20591 33.0987 4.90692 34.0831 4.90692C35.2961 4.90692 36.357 5.34305 37.0647 6.02422C38.3269 7.22358 38.3772 8.53084 38.3772 11.8007V19.3194H34.6638V12.6426C34.6638 10.3799 34.6135 9.91679 34.2351 9.31767C33.8304 8.66685 33.2496 8.53084 32.694 8.53084C32.0571 8.52765 31.4598 8.83391 31.098 9.34915C30.6932 10.0303 30.6932 11.2016 30.6932 12.3459V19.3228H26.9776V12.2098C26.9776 10.6834 26.9776 10.0022 26.6026 9.37163C26.2827 8.84841 25.7075 8.52811 25.0866 8.52747C24.7505 8.52849 24.4201 8.61317 24.1263 8.77364C23.0402 9.36938 23.015 10.408 23.015 13.0787V19.3228H15.2019L14.0095 15.2257ZM13.0011 11.7029L11.0072 4.27295L9.11397 11.7029H13.0011Z"
        fill="#2C2C2C"
      />
      <path
        d="M77.8716 21.7001V20.3929H78.3643V20.1152H77.0225V20.3929H77.5288V21.7001H77.8716Z"
        fill="#2C2C2C"
      />
      <path
        d="M79.9129 21.7001H80.243V20.1242H79.8028L79.444 21.3186L79.0654 20.1152H78.6328V21.6911H78.963L78.9443 20.7827C78.9432 20.6773 78.9355 20.572 78.9212 20.4676C78.93 20.5058 78.9828 20.6826 78.9916 20.7208L79.2855 21.7001H79.5816L79.8743 20.7298C79.8985 20.6387 79.9261 20.534 79.9448 20.4676C79.9448 20.525 79.9261 20.6927 79.9261 20.7917L79.9129 21.7001Z"
        fill="#2C2C2C"
      />
    </svg>
  );
};
